import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { Subscription } from 'rxjs';

import { LangDefinition, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'schaeffler-language-select',
  templateUrl: './language-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LanguageSelectComponent implements OnInit, OnDestroy {
  @Input() public reloadOnLanguageChange = false;

  protected readonly transloco = inject(TranslocoService);
  protected readonly availableLanguages =
    this.transloco.getAvailableLangs() as LangDefinition[];
  protected readonly languageSelectControl: UntypedFormControl =
    new UntypedFormControl(this.transloco.getActiveLang());

  private readonly subscription = new Subscription();

  public ngOnInit(): void {
    this.subscription.add(
      this.transloco.langChanges$.subscribe((language) => {
        this.languageSelectControl.setValue(language);
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onLanguageSelectionChange(lang: string): void {
    this.transloco.setActiveLang(lang);

    if (this.reloadOnLanguageChange) {
      location.reload();
    }
  }
}
